import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "gatsby";
// import LanguageSelect from "../../../components/LanguageSelect";
import SocialMediaItems from "../../../components/SocialMediaItems";

import SectionLink from "../../../components/SectionRouteLink/SectionRouteLink";

import {
  StyledContainer,
  StyledInnerContainer,
  StyledUl,
  StyledLi,
  StyledSocialMediaContainer,
  StyledBottomContainer,
  StyledRightReserved,
  StyledListTitle,
} from "./MainFooterStyle";

const MainFooter = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledInnerContainer>
        <StyledUl>
          <StyledLi>
            <StyledListTitle>What we offer</StyledListTitle>
          </StyledLi>
          {/* <StyledLi>
            <span>Identity Verification</span>
          </StyledLi> */}
          <StyledLi>
            <Link
              to="/document-verification"
              aria-label="Document verification"
            >
              Document Verification
            </Link>
          </StyledLi>
          <StyledLi>
            <Link to="/liveness-and-age" aria-label="Liveness and age">
              Liveness Check
            </Link>
          </StyledLi>
          <StyledLi>
            <a
              href="https://www.liveness.com/"
              aria-label="Liveness KYC"
              target="_blank"
              rel="noreferrer"
            >
              KYC
            </a>
          </StyledLi>
        </StyledUl>
        <StyledUl>
          <StyledLi>
            <StyledListTitle>Use Cases</StyledListTitle>
          </StyledLi>
          <StyledLi>
            <SectionLink
              to="#industries"
              state={{ active: "financialService" }}
            >
              Financial Services
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <SectionLink to="#industries" state={{ active: "gambling" }}>
              Gambling
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <SectionLink to="#industries" state={{ active: "sharingEconomy" }}>
              Sharing Economy
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <SectionLink
              to="#industries"
              state={{ active: "retailAndCommerce" }}
            >
              Retail and eCommerce
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <SectionLink
              to="#industries"
              state={{ active: "teleCommunication" }}
            >
              Telecommunications
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <SectionLink to="#industries" state={{ active: "education" }}>
              Online Education and Testing Services
            </SectionLink>
          </StyledLi>
        </StyledUl>
        <StyledUl>
          <StyledLi>
            <StyledListTitle>About</StyledListTitle>
          </StyledLi>
          {/* <StyledLi>
            <Link>About Company</Link>
          </StyledLi> */}
          <StyledLi>
            <SectionLink to="#contact" aria-label="contact">
              Contact
            </SectionLink>
          </StyledLi>
          <StyledLi>
            <Link to="/blog" aria-label="blog">
              Blog
            </Link>
          </StyledLi>
          <StyledLi>
            <Link to="/about-us" aria-label="about-us">
              About Us
            </Link>
          </StyledLi>
          {/* <StyledLi>
            <a
              href="https://vobi.io/"
              aria-label="vobi"
              target="_blank"
              rel="noreferrer"
            >
              VOBI - Strategic Partner
            </a>
          </StyledLi> */}
        </StyledUl>
        <StyledUl>
          <StyledLi>
            <StyledListTitle>Legal</StyledListTitle>
          </StyledLi>
          <StyledLi>
            <Link to="/terms-of-use" aria-label="terms-of-use">
              Terms of Use
            </Link>
          </StyledLi>
          <StyledLi>
            <Link to="/privacy-policy" aria-label="privacy-policy">
              Privacy Policy
            </Link>
          </StyledLi>
          <StyledLi>
            <Link to="/cookie-policy" aria-label="cookie-policy">
              Cookie Policy
            </Link>
          </StyledLi>
        </StyledUl>
      </StyledInnerContainer>
      <StyledBottomContainer>
        <StyledRightReserved>{t("AllRightReserved")}</StyledRightReserved>
        <StyledSocialMediaContainer>
          <SocialMediaItems />
        </StyledSocialMediaContainer>
      </StyledBottomContainer>
    </StyledContainer>
  );
};

export default MainFooter;
